export default [
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/message/index'),
    meta: {
      title: '消息'
    }, 
  },  
  {
    path: '/message/detail',
    name: 'messageDetail',
    component: () => import('@/views/message/messageDetail'),
    meta: {
      title: '消息详情'
    }, 
  },
]